var React = require('react');

function FrontendDropdownMenuBroadcasts (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"}));
}

FrontendDropdownMenuBroadcasts.displayName = "FrontendDropdownMenuBroadcasts";

FrontendDropdownMenuBroadcasts.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuBroadcasts;

FrontendDropdownMenuBroadcasts.default = FrontendDropdownMenuBroadcasts;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-broadcasts.svg
// module id = 1008
// module chunks = 0